import DealLockReason from "@app/enum/DealLockReason";

import notifyDealLocked from "./notifyDealLocked";

// Both activity relate flows skip relinking a read-only deal; this tells the rep why
const notifyDealRelinkLocked = () => notifyDealLocked(DealLockReason.STAGE_READ_ONLY);

export default notifyDealRelinkLocked;
